// Pagina principală: bannerul cu cadre (buclă, swipe) și rafturile derulabile (săgeți, muchie).
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lei = function (n) { return n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' lei'; };
  var tpl = function (id) { return document.getElementById(id).innerHTML; };

  // ---------- cardul mare: carusel cu transform, buclă infinită (clone la capete), swipe ----------
  var car = document.querySelector('.cadre'); if (car) (function () {
  var dots = [].slice.call(document.querySelectorAll('.hero-dots button')), timer;
  var slides = [].slice.call(car.children), n = slides.length, idx = 1, anim = false;
  var track = document.createElement('div'); track.className = 'cadre-track';
  var cl = function (el) { var c = el.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.querySelectorAll('a,button').forEach(function (e) { e.tabIndex = -1; }); return c; };
  track.appendChild(cl(slides[n - 1])); slides.forEach(function (s) { track.appendChild(s); }); track.appendChild(cl(slides[0]));
  car.appendChild(track);
  function pune(i, cuAnim) { track.style.transition = cuAnim && !reduce ? 'transform .6s cubic-bezier(.16,1,.3,1)' : 'none'; track.style.transform = 'translate3d(' + (-i * 100) + '%,0,0)'; }
  function marcheaza() { var r = (idx - 1 + n) % n; dots.forEach(function (d, j) { d.toggleAttribute('aria-current', j === r); d.classList.toggle('trecut', j < r); d.classList.remove('umple'); if (j === r && !reduce) { d.offsetWidth; d.classList.add('umple'); } }); slides.forEach(function (s, j) { s.toggleAttribute('inert', j !== r); }); }
  function mergi(i) { if (anim) return; anim = !reduce; idx = i; pune(idx, true); marcheaza(); if (reduce) fix(); }
  function fix() { anim = false; if (idx === 0) { idx = n; pune(idx, false); } else if (idx === n + 1) { idx = 1; pune(idx, false); } }
  track.addEventListener('transitionend', function (e) { if (e.target === track) fix(); });
  pune(idx, false); marcheaza();
  dots.forEach(function (d, i) { d.addEventListener('click', function () { mergi(i + 1); porneste(); }); });
  document.querySelectorAll('[data-hn]').forEach(function (b) { b.addEventListener('click', function () { mergi(idx + (+b.dataset.hn)); porneste(); }); });
  // swipe cu degetul sau mouse-ul
  var x0 = null, y0 = 0, dx = 0, oriz = null;
  track.addEventListener('pointerdown', function (e) { if (anim) return; x0 = e.clientX; y0 = e.clientY; dx = 0; oriz = null; clearInterval(timer); });
  track.addEventListener('pointermove', function (e) {
    if (x0 === null) return; var mx = e.clientX - x0, my = e.clientY - y0;
    if (oriz === null && (Math.abs(mx) > 6 || Math.abs(my) > 6)) oriz = Math.abs(mx) > Math.abs(my);
    if (!oriz) return; dx = mx; track.style.transition = 'none'; track.style.transform = 'translate3d(calc(' + (-idx * 100) + '% + ' + dx + 'px),0,0)';
  });
  function gata() { if (x0 === null) return; var w = car.clientWidth; x0 = null; if (oriz && Math.abs(dx) > w * 0.15) mergi(idx + (dx < 0 ? 1 : -1)); else pune(idx, true); porneste(); }
  track.addEventListener('pointerup', gata); track.addEventListener('pointercancel', gata); track.addEventListener('pointerleave', gata);
  track.addEventListener('click', function (e) { if (Math.abs(dx) > 6) { e.preventDefault(); dx = 0; } }, true);
  function porneste() { clearInterval(timer); if (!reduce) timer = setInterval(function () { mergi(idx + 1); }, 6000); }
  car.addEventListener('focusin', function () { clearInterval(timer); });
  porneste();

  })();

  // ---------- rafturile: săgeți și muchia de raft ----------
  var rafturi = [].slice.call(document.querySelectorAll('.raft'));
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sag]'); if (!b) return;
    var s = b.closest('.raft').querySelector('.sina');
    s.scrollBy({ left: +b.dataset.sag * s.clientWidth * 0.85, behavior: 'smooth' });
  });
  function muchie(r) {
    var s = r.querySelector('.sina'), max = s.scrollWidth - s.clientWidth;
    r.style.setProperty('--vazut', (max <= 0 ? 1 : (s.scrollLeft + s.clientWidth) / s.scrollWidth).toFixed(3));
    var b = r.querySelectorAll('[data-sag]'); b[0].disabled = s.scrollLeft <= 2; b[1].disabled = s.scrollLeft >= max - 2;
    r.classList.toggle('fara-sageti', max <= 2);
  }
  rafturi.forEach(function (r) {
    var s = r.querySelector('.sina'), tick = false;
    s.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(function () { muchie(r); tick = false; }); } }, { passive: true });
    muchie(r);
  });
  window.addEventListener('resize', function () { rafturi.forEach(muchie); });

})();
